// extracted by mini-css-extract-plugin
export default {"no_data":"DataTable_no_data__TJbC8","no_data_text":"DataTable_no_data_text__6CZ8f","no_img":"DataTable_no_img__Wn0uA"};